{
  "name": "@minima-global/create-minima-app",
  "version": "0.2.3",
  "files": [
    "dist",
    "templates",
    "README.md"
  ],
  "type": "module",
  "exports": "./dist/index.js",
  "bin": {
    "create-minima-app": "./dist/index.js"
  },
  "publishConfig": {
    "access": "public"
  },
  "keywords": [
    "minima",
    "typescript",
    "mds",
    "minidapps",
    "minima-blockchain",
    "web3"
  ],
  "homepage": "https://github.com/minima-global/dev-tools",
  "bugs": {
    "url": "https://github.com/minima-global/dev-tools/issues"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/minima-global/dev-tools"
  },
  "author": "Minima Global",
  "license": "MIT",
  "scripts": {
    "build": "tsup",
    "dev": "tsup --watch",
    "lint": "eslint .",
    "clean": "rm -rf dist",
    "format": "prettier --write \"./src/**/**.ts\" --write",
    "check-format": "prettier \"./src/**/**.ts\" --check"
  },
  "dependencies": {
    "@minima-global/mds": "0.14.11",
    "@minima-global/minima-cli": "0.1.5",
    "axios": "^1.7.7",
    "chalk": "^5.3.0",
    "commander": "^12.1.0",
    "figlet": "^1.8.0",
    "ora": "^8.1.1",
    "prompts": "^2.4.2",
    "puppeteer": "^23.9.0",
    "zod": "^3.23.8",
    "vite": "^6.0.2"
  },
  "devDependencies": {
    "@types/figlet": "^1.7.0",
    "@types/fs-extra": "^11.0.4",
    "@types/node": "^20.14.10",
    "@types/prompts": "^2.4.9",
    "@typescript-eslint/eslint-plugin": "^6.0.0",
    "@typescript-eslint/parser": "^6.0.0",
    "eslint": "^8.0.0",
    "tsup": "^8.0.0",
    "typescript": "^5.0.0"
  }
}
